var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('svg',{staticClass:"icon",class:( _obj = {}, _obj[_vm.props.name] = true, _obj ),style:(_vm.props.customStyle)},[_c('use',{attrs:{"xlink:href":("#" + (_vm.props.name))}})])}
var staticRenderFns = []

export { render, staticRenderFns }